import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const UnifiedPullDown = ({
                               onPullDown,
                               threshold = 60,
                               children,
                               sx = {},
                           }) => {

    const startY = useRef(0);
    const deltaY = useRef(0);
    const pulling = useRef(false);
    const scrollRef = useRef(null);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        const handleTouchStart = (e) => {
            startY.current = e.touches[0].clientY;
            deltaY.current = 0;
            pulling.current = el.scrollTop <= 0; // only allow pull if at top
        };

        const handleTouchMove = (e) => {
            const currentY = e.touches[0].clientY;
            deltaY.current = currentY - startY.current;

            if (pulling.current && deltaY.current > threshold && typeof onPullDown === 'function') {
                if (e.cancelable) e.preventDefault(); // iOS only allows if cancelable
                onPullDown();
                pulling.current = false;
            }
        };

        const handleTouchEnd = () => {
            pulling.current = false;
        };

        el.addEventListener('touchstart', handleTouchStart, { passive: true });
        el.addEventListener('touchmove', handleTouchMove, { passive: false }); // passive: false is key for iOS
        el.addEventListener('touchend', handleTouchEnd);

        return () => {
            el.removeEventListener('touchstart', handleTouchStart);
            el.removeEventListener('touchmove', handleTouchMove);
            el.removeEventListener('touchend', handleTouchEnd);
        };
    }, [onPullDown, threshold]);

    return (
        <div
            ref={scrollRef}
            style={{
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                overscrollBehavior: 'contain',
                height: '100%',
                position: 'relative',
                touchAction: 'pan-y',
            }}
        >
            {children}
        </div>
    );
};

UnifiedPullDown.propTypes = {
    onPullDown: PropTypes.func.isRequired,
    threshold: PropTypes.number,
    children: PropTypes.node.isRequired,
    sx: PropTypes.object,
};

export default UnifiedPullDown;

